<template>
  <div>
    <div class="ml-2 mt-12 text-h5">広島県のお知らせ分類登録</div>
    <div class="ml-4 blue-grey--text">赤印のある項目は必須入力です</div>
    <alert :errors="errors" css_class="ma-1"></alert>
    <v-container style="max-width: 800px" v-show="view_status.editable">
      <v-row
        v-for="input in inputs"
        :key="input.key"
        no-gutters
        dense
        class="mb-2"
      >
        <v-col cols="4">
          <v-subheader class="title mr-2" style="height: 100%"
            >{{ input.title
            }}<v-icon class="ml-1 mb-3 red--text caption" v-if="input.required"
              >mdi-asterisk</v-icon
            ></v-subheader
          ></v-col
        >
        <v-col>
          <v-text-field
            v-if="input.key == 'category'"
            outlined
            dense
            hide-details="auto"
            :label="input.title"
            v-model.trim="$v.formData.category.$model"
            :error-messages="categoryErrorMessage"
            :error-count="3"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-container style="max-width: 800px">
      <v-row justify="center" style="text-align: center">
        <v-col cols="6">
          <v-btn
            color="secondary"
            outlined
            class="ma-2"
            width="200"
            @click="cancel"
            >キャンセル</v-btn
          >
        </v-col>
        <v-col cols="6">
          <v-btn
            color="primary"
            class="ma-2"
            width="200"
            @click="register"
            :disabled="!view_status.editable"
            >登録</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Api from "@/logic/api/api.js";
import Validate from "@/logic/common/validate.js";
import Roles from "@/logic/common/roles.js";
import Alert from "../components/common/alert.vue";
import AlertBuilder from "../logic/common/alert-contents";
import { required, maxLength } from "vuelidate/lib/validators";
import valueMapper from "../logic/common/value-mapper";

export default {
  components: {
    alert: Alert,
  },
  validations: {
    formData: {
      category: {
        required,
        maxLength: maxLength(64),
      },
    },
  },
  computed: {
    disableRegisterButton() {
      return Validate.hasError([this.$v.formData.category]);
    },
    categoryErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
        this.$v.formData.category,
        "分類",
        ["required", "maxLength"],
        !this.delayCheck
      );
    },
  },
  data() {
    // URLから参照先を取得する
    const uid = this.$route.params.uid;
    const isCreate = uid == "create" ? true : false;
    console.log("uid = " + uid);
    console.log("isCreate = " + isCreate);
    // 画面に表示する項目
    const inputs = [];
    inputs.push({
      key: "category",
      title: "分類",
      required,
    });
    this.$nextTick(() => {
      this.loadData(uid);
    });
    return {
      view_status: {
        editable: false,
      },
      isCreate: isCreate,
      recordId: uid,
      permission: {
          text: "-",
          value: null,
      },
      permissionRoles: Roles.groupToGroupRoles(),
      inputs: inputs,
      delayCheck: false,
      parentGroup: {
        text: "-",
        value: "",
      },
      parentList: [],
      formData: {
        category: "",
      },
      updateData: {
        restrictedIds: [],
      },
      errors: [],
    };
  },
  methods: {
    /**
     * 分類を取得、画面に表示する
     */
    loadData(uid) {
      console.log("loadData(uid) = " + uid);
      this.view_status.editable = false;
      this.$store.commit("setWaiting", true);
      this.$nextTick(() => {
        // 分類を反映する
        console.log("displayCategoryData");
        const displayCategoryData = (category) => {
          // 分類を設定する
          console.log("category.category = " + category.category);
          this.formData.category = category.category;
        };
        const apiRequests = [];
        const processList = [];

        // 分類を取得する
        apiRequests.push("category.list");
        processList.push(
          Api.call("/admin/hiroshima/information/category", {})
        );

        // 必要なAPIを全て実行する
        Promise.all(processList)
          .then((result) => {
            this.$store.commit("setWaiting", false);
            if (apiRequests.includes("category.list")) {
              var categoryList = result[apiRequests.indexOf("category.list")].categorys;
              console.log("categoryList = ");
              console.log(JSON.stringify(categoryList));
              if (uid != "create") {
                var found = categoryList.find(e => e.record_id == uid);
                console.log("found = " + JSON.stringify(found));
                displayCategoryData(found);
              }
            }
            this.view_status.editable = true;
          })
          .catch((result) => {
            // エラーになったリクエストが一つでもあればここに入る
            this.$store.commit("setWaiting", false);
            const message = valueMapper
              .map({
                403: AlertBuilder.error("権限がありません"),
              })
              .getOrElse(result.status, AlertBuilder.invalid());
            if (message.isInvalid) {
              Api.resolve(result);
            } else {
              this.showMessage(message);
            }
          });
      });
    },
    /**
     * メッセージを初期化する
     */
    clearMessage() {
      this.errors = [];
    },
    /**
     * メッセージを表示する
     */
    showMessage(error) {
      this.errors.push(error);
      window.scrollTo(0, 0);
    },
    /**
     * 登録データを作成する
     */
    sendBaseData() {
      console.log("this.formData.category = " + this.formData.category);
      console.log("characterSet = " + this.formData.category.characterSet);
      return {
        category: this.formData.category,
      };
    },
    /**
     * 登録データを作成する
     */
    buildRegisterData() {
      return {
        ...this.sendBaseData(),
      };
    },
    /**
     * 更新データを作成する
     */
    buildUpdateData() {
      console.log("this.recordId = " + this.recordId);
      console.log("this.uid = " + this.uid);
      return {
        record_id: Number(this.recordId),
        ...this.sendBaseData(),
      };
    },
    /**
     * データを登録する
     */
    register() {
      this.delayCheck = true;
      this.clearMessage();
      console.log("register()");
      // リクエストパラメータを作成する
      let updateUrl = "";
      let postData = null;
      if (this.isCreate) {
        updateUrl = "/admin/hiroshima/information/category/create";
        postData = this.buildRegisterData();
        console.log("postData(create) = " + JSON.stringify(postData));
      } else {
        updateUrl = "/admin/hiroshima/information/category/update";
        console.log("postData(update) = " + JSON.stringify(postData));
        postData = this.buildUpdateData();
      }
      // APIを実行する
      this.$store.commit("setWaiting", true);
      console.log("Api.call in category-edit.vue");
      console.log("updateUrl = " + updateUrl);
      console.log("postData = " + JSON.stringify(postData));
      Api.call(updateUrl, postData)
        .then(() => {
          this.$store.commit("setWaiting", false);
          this.$router.push("/prefcategory");
        })
        .catch((error) => {
          this.$store.commit("setWaiting", false);
          console.log("error = " + error);
          console.log("error.status = " + error.status);
          if (!error.status) {
            console.log("JSONエラーは後で確認");
            this.$store.commit("setWaiting", false);
            this.$router.push("/prefcategory");
          }
          const message = valueMapper
            .map({
              401: AlertBuilder.invalid(),
              409: AlertBuilder.error("編集が競合しています"),
            })
            .getOrElse(error.status, AlertBuilder.error("更新に失敗しました"));
          if (message.isInvalid) {
            Api.resolve(error);
          } else {
            this.showMessage(message);
          }
        });
    },
    cancel() {
      this.$router.push("/prefcategory");
    },
  },
};
</script>

<style scoped>
.title {
  background-color: #999999;
  color: white;
}
</style>
